module.exports = __webpack_public_path__ + "img/kreis-leer.718a943c.svg";